<template>
  <div>
    <draggable
      v-bind="dragOptions"
      tag="ul"
      class="list-group list-group-flush lesson-list"
      :list="list"
      :value="value"
      handle=".handle-lesson"
      @input="emitter"
      :move="onMove"
    >
      <transition-group type="transition" name="flip-list">
        <li
          class="list-group-item draggable lesson-group"
          :key="lesson.id"
          v-for="(lesson, key) in realValue"
        >
          <div class="row lesson-item no-gutters align-items-center">
            <div class="col-auto ml-4">
              <i v-if="!readOnly" class="fa fa-align-justify handle-lesson"></i>
              <template v-else>
                <span v-if="lesson.progress === 'progress.not_started'">●</span>
                <span v-else-if="lesson.progress === 'progress.in_progress'" class="text-info">●</span>
                <span v-else-if="lesson.progress === 'progress.done'" class="text-success">✓</span>
              </template>
            </div>
            <div class="col ml-4 col-title">
              <h4 class="mb-0">
                <router-link v-if="readOnly" :to="publicLessonPageUrl(lesson.id)">{{ lesson.title }}</router-link>
                <!-- <router-link v-else :to="editLessonRoute(lesson.id)">{{ lesson.title }}</router-link> -->
                <a v-if="!readOnly" :href="'/e/' + lesson.id" >
                  {{ lesson.title }}
                </a>
              </h4>
            </div>
            <div v-if="!readOnly" class="col-auto pr-2 col-status">
              <el-tooltip
                class="lesson-tooltip"
                v-if="lesson.isVisible"
                :content="$t('visible for users')"
                :openDelay="300"
                effect="light"
                placement="left"
              >
                <i class="fa fa-eye" aria-hidden="true"></i>
              </el-tooltip>
              <el-tooltip
                class="lesson-tooltip"
                v-if="!!lesson.videoId"
                :content="$t('has video')"
                :openDelay="300"
                effect="light"
                placement="left"
              >
                <i class="fa fa-film" aria-hidden="true"></i>
              </el-tooltip>
              <el-tooltip
                class="lesson-tooltip"
                v-if="lesson.isAvailable"
                :openDelay="300"
                effect="light"
                :content="$t('enabled to do')"
                placement="bottom"
              >
                <i class="fa fa-check" aria-hidden="true"></i>
              </el-tooltip>
              <el-tooltip
                v-if="lesson.isFree"
                :openDelay="300"
                effect="light"
                :content="$t('it is free lesson')"
                placement="top"
              >
                <i class="fa fa-unlock" aria-hidden="true"></i>
              </el-tooltip>
            </div>
            <div v-if="!readOnly" class="col-auto col-actions">
              <el-dropdown trigger="click" class="dropdown">
                <span class="btn btn-flat">
                  <i class="fas fa-ellipsis-v"></i>
                </span>
                <el-dropdown-menu class="dropdown-menu dropdown-menu-arrow show" slot="dropdown">
                  <a
                    class="dropdown-item"
                    @click="addAnswerTask(lesson.id)"
                  >Добавить задание (текстовый ответ)</a>
                  <a class="dropdown-item" @click="addFormTask(lesson.id)">Добавить форму</a>
                  <a class="dropdown-item" @click="addQuizTask(lesson.id)">Добавить опросник</a>
                  <a class="dropdown-item" @click="addCodeTask(lesson.id)">Добавить задание-код</a>
                  <a class="dropdown-item" @click="addSQLTask(lesson.id)">Добавить задание-базы данных </a>
                  <a
                    class="dropdown-item"
                    @click="addUploadTask(lesson.id)"
                  >Добавить форму загрузки файла</a>
                  <hr class="my-2 mx-0" />
                  <router-link
                    class="dropdown-item"
                    :to="{name: 'learn-lesson-page', params: {...$route.params, blockId, lessonId: lesson.id}}"
                  >
                    <i class="fas fa-eye"></i>Посмотреть как студент
                  </router-link>
                  <a class="dropdown-item text-warning" @click="confirmDelete(lesson.id)">
                    <i class="fas fa-trash-alt"></i>Удалить
                  </a>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </div>
          <task-draggable-list
            v-if="mode !== 'student'"
            @input="childEmitter"
            :lessonId="lesson.id"
            :blockId="blockId"
            :read-only="readOnly"
            v-model="lesson.tasks"
          ></task-draggable-list>
        </li>
        <li v-if="!readOnly" class="list-group-item draggable lesson-group" :key="-1">
          <div class="row lesson-button align-items-center">
            <div class="col">
              <router-link :to="addLessonRoute">
                <button type="button" class="btn btn-sm btn-info ml-4">{{ $t('Add lesson') }}</button>
              </router-link>
            </div>
          </div>
        </li>
      </transition-group>
    </draggable>
    <modal-delete-confirmation
      v-if="!readOnly"
      ref="block-delete-confirmation"
      v-model="showModal"
      :text="textModal"
      :id="idModal"
      @confirmed="onDeleteLesson"
    ></modal-delete-confirmation>
  </div>
</template>

<script>
import draggable from "vuedraggable";
import { Tooltip, DropdownMenu, Dropdown } from "element-ui";
import TaskDraggableList from "./TaskDraggableList";
import ModalDeleteConfirmation from "../Modals/ModalDeleteConfirmation";
import { createNamespacedHelpers } from "vuex";
import { DeleteConfirmation } from "../../mixins/DeleteConfirmation";
import { ProgressConstantsMixin } from "../../mixins/Constants";
const { mapActions } = createNamespacedHelpers("course/lesson");

export default {
  name: "LessonDraggableList",
  mixins: [DeleteConfirmation, ProgressConstantsMixin],
  data() {
    return {
      learnButtonLoading: false,
    };
  },
  methods: {
    // Author methods
    emitter(value) {
      this.$emit("input", value);
    },
    childEmitter() {
      this.$emit("input", this.value);
    },
    onMove(evt) {
      return evt.related.classList.contains("lesson-group");
    },
    ...mapActions({
      deleteLesson: "deleteLesson",
    }),
    async onDeleteLesson(id) {
      this.$wait.start("course content fetching");
      await this.deleteLesson({ urlParams: this.urlParams(id) });
      await this.$store.dispatch("course/content/load", {
        urlParams: this.$route.params,
      });
      this.$wait.end("course content fetching");
    },
    async addFormTask(lessonId) {
      await this.$router.push({
        name: "task-form-add",
        params: this.urlParams(lessonId),
      });
    },
    async addQuizTask(lessonId) {
      await this.$router.push({
        name: "task-quiz-add",
        params: this.urlParams(lessonId),
      });
    },
    async addAnswerTask(lessonId) {
      await this.$router.push({
        name: "task-answer-add",
        params: this.urlParams(lessonId),
      });
    },
    async addCodeTask(lessonId) {
      await this.$router.push({
        name: "task-code-add",
        params: this.urlParams(lessonId),
      });
    },
    async addSQLTask(lessonId) {
      await this.$router.push({
        name: "task-sql-add",
        params: this.urlParams(lessonId),
      });
    },
    async addUploadTask(lessonId) {
      await this.$router.push({
        name: "task-upload-add",
        params: this.urlParams(lessonId),
      });
    },
  },
  components: {
    ModalDeleteConfirmation,
    TaskDraggableList,
    [Tooltip.name]: Tooltip,
    [Dropdown.name]: Dropdown,
    [DropdownMenu.name]: DropdownMenu,
    draggable,
  },
  computed: {
    dragOptions() {
      return {
        animation: 0,
        group: "description",
        disabled: false,
        ghostClass: "ghost",
      };
    },
    baseUrlParams() {
      return {
        courseId: this.$route.params.courseId,
        blockId: this.blockId,
      };
    },
    urlParams() {
      return (id = undefined) => {
        return id
          ? { ...this.baseUrlParams, lessonId: id }
          : this.baseUrlParams;
      };
    },
    // this.value when input = v-model
    // this.list when input != v-model
    realValue() {
      return this.value ? this.value : this.list;
    },
    textModal() {
      return this.$i18n.t("modal.lessonDelete.text", this.idModal);
    },
    addLessonRoute() {
      return {
        name: "lesson-add",
        params: this.urlParams(),
      };
    },
    editLessonRoute() {
      return (id) => {
        return {
          name: "lesson-edit",
          params: this.urlParams(id),
        };
      };
    },
    publicLessonPageUrl() {
      return (id) => {
        return {
          name: "learn-lesson-page",
          params: this.urlParams(id),
        };
      };
    },
    parallelModeCourse() {
      return false;
    },
  },
  props: {
    value: {
      required: false,
      type: Array,
      default: null,
    },
    list: {
      required: false,
      type: Array,
      default: null,
    },
    blockId: {
      required: true,
      type: Number,
    },
    readOnly: {
      type: Boolean,
      default: false,
    },
    mode: {
      type: String,
      default: "author",
    },
  },
};
</script>
